import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { BasicCard } from '@uhg-skyline/react-core';

const bannerImage = `${process.env.PUBLIC_URL}/images/homepage-banner.png`;

const HomePage: React.FC = () => {
  return (
      <Box sx={{ width: "100%", margin: "0 auto", padding: "32px" }}>
        <BasicCard
          cardColor="default"
          borderRadiusSize="largeBorderRadius"
          sx={{
            marginBottom: "36px",
            overflow: "hidden",
            "&.Material-baseCard.largeBorderRadius": { padding: "0" },
          }}
        >
          <Grid container alignItems="center" sx={{ gap: { xs: "24px", md: "48px" } }}>
            <Grid item xs={12} md sx={{ flex: 1, padding: { xs: "32px", md: "48px 0 48px 48px" } }}>
              <Typography
                component="h1"
                sx={{
                  fontFamily: "EnterpriseSerifTextVF, serif",
                  fontWeight: 400,
                  fontSize: "48px",
                  color: "#3D3C38",
                  lineHeight: "120%",
                  letterSpacing: "-0.02em",
                  marginBottom: "24px",
                  "& span": {
                    fontFamily: "EnterpriseSerifTextVF, serif",
                    fontWeight: 500,
                    fontStyle: "italic",
                    fontSize: "48px",
                    color: "#3D3C38",
                    lineHeight: "120%",
                    letterSpacing: "-0.02em",
                    verticalAlign: "middle",
                  },
                }}
              >
                Welcome to Advanced Claim View a more <span>powerful modern system</span>
              </Typography>
              <Typography
                component="p"
                sx={{
                  fontFamily: "EnterpriseSansVF, Arial, sans-serif",
                  fontWeight: 400,
                  fontSize: "18px",
                  color: "#3D3C38",
                  lineHeight: "140%",
                }}
              >
                Advanced Claim View brings together Eligibility, Provider, Adjudication, Plan, Pricing, and other core applications into a single, modern experience. With streamlined navigation, improved usability, and a consistent design across workflows, you can access the tools and information you need faster and work with greater confidence.
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              md
              sx={{ flex: 1, padding: { xs: "0 32px 32px", md: "32px 32px 32px 0" }, display: "flex", justifyContent: { xs: "center", md: "flex-end" } }}
            >
              <Box
                component="img"
                src={bannerImage}
                alt="Advanced Claim View"
                sx={{ display: "block", maxWidth: "100%", height: "auto", maxHeight: "450px", objectFit: "contain" }}
              />
            </Grid>
          </Grid>
        </BasicCard>

        <Grid container sx={{ gap: { xs: "24px", md: "48px" } }}>
          <Grid item xs={12} md sx={{ flex: 1 }}>
            <Typography
              component="h2"
              sx={{
                fontFamily: "EnterpriseSansVF, Arial, sans-serif",
                fontWeight: 700,
                fontSize: "32px",
                color: "#000",
                lineHeight: "120%",
                letterSpacing: "-0.02em",
                marginBottom: "36px",
              }}
            >
              Same trusted capabilities.<br />A better way to work.
            </Typography>
            <Typography
              component="p"
              sx={{
                fontFamily: "EnterpriseSansVF, Arial, sans-serif",
                fontWeight: 400,
                color: "#000",
                fontSize: "18px",
                lineHeight: "140%",
              }}
            >
              By reducing the need to navigate between systems and presenting information in a more consistent way, Advanced Claim View helps simplify complex processes and improve productivity.
            </Typography>
          </Grid>
          <Grid item xs={12} md sx={{ flex: 1 }}>
            <Typography
              component="h3"
              sx={{
                fontFamily: "EnterpriseSansVF, Arial, sans-serif",
                fontWeight: 700,
                fontSize: "23px",
                color: "#000",
                lineHeight: "120%",
                letterSpacing: "-0.02em",
              }}
            >
              What's New
            </Typography>
            <Box
              component="ul"
              sx={{
                fontFamily: "EnterpriseSansVF, Arial, sans-serif",
                fontWeight: 400,
                fontSize: "18px",
                color: "#000",
                lineHeight: "140%",
                "& li": { marginBottom: "8px" },
                "& li:last-child": { marginBottom: 0 },
              }}
            >
              <li>Modernized user experience and visual design</li>
              <li>Simplified navigation across applications</li>
              <li>Consistent workflows across the platform</li>
              <li>Faster access to critical information and actions</li>
              <li>Enhanced productivity without sacrificing functionality</li>
            </Box>
          </Grid>
        </Grid>
      </Box>
    );
};

export default HomePage;